import { render, staticRenderFns } from "./TickerSection.vue?vue&type=template&id=9d45c96a&"
import script from "./TickerSection.vue?vue&type=script&lang=js&"
export * from "./TickerSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports